export default __webpack_public_path__ + "static/media/p-plus.9528a600.svg";